<template>
  <div class="password-rating" :class="`password-rating--${rating}`">
    <div class="password-rating__lines lines">
      <div class="lines__item" v-for="n in linesCount" :key="n"></div>
    </div>

    <div class="password-rating__info">
      {{ $t(`${rating}RatingPasswordTitle`) }}
      <RatingDescription
        :password="password"
        :isDescriptionHintsOpen="isDescriptionHintsOpen"
        @descriptionHintsClick="$emit('descriptionHintsClick')"
        v-click-outside="hideHints"
      />
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

import {
  WEAK_PASSWORD,
  MEDIUM_PASSWORD,
  STRONG_PASSWORD,
} from '@/constants/constants';

import RatingDescription from './RatingDescription.vue';

const LINES_COUNT = 3;

/* eslint-disable */
// минимум 8 символов + должен состоять из 4-х типов символов
const STRONG_1 =
  '(?:(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[_\\W])[0-9a-zA-Z_\\W]{8,})';

// минимум 10 символов + должен состоять из 3-х любых типов символов
const STRONG_2 =
  '(?:(?=.*[0-9a-z])(?=.*[0-9A-Z])(?=.*[0-9_\\W])(?=.*[a-zA-Z])(?=.*[a-z_\\W])(?=.*[A-Z_\\W])[0-9a-zA-Z_\\W]{10,})';

// минимум 14 символов + должен состоять из 2-х любых типов символов
const STRONG_3 =
  '(?:(?=.*[0-9a-zA-Z])(?=.*[a-zA-Z_\\W])(?=.*[0-9A-Z_\\W])(?=.*[0-9a-z_\\W])[0-9a-zA-Z_\\W]{14,})';
const STRONG_PASSWORD_REGEXP = `${STRONG_1}|${STRONG_2}|${STRONG_3}`;

// минимум 6 символов + должен состоять из 3-х любых типов символов
const MEDIUM_1 =
  '(?:(?=.*[0-9a-z])(?=.*[0-9A-Z])(?=.*[0-9_\\W])(?=.*[a-zA-Z])(?=.*[a-z_\\W])(?=.*[A-Z_\\W])[0-9a-zA-Z_\\W]{6,})';

// минимум 8 символов + должен состоять из 2-х любых типов символов
const MEDIUM_2 =
  '(?:(?=.*[0-9a-zA-Z])(?=.*[a-zA-Z_\\W])(?=.*[0-9A-Z_\\W])(?=.*[0-9a-z_\\W])[0-9a-zA-Z_\\W]{8,})';

// минимум 14 символов + должен состоять из 1-ого любого типа символов
const MEDIUM_3 = '(?:[0-9a-zA-Z_\\W]{14,})';
const MEDIUM_PASSWORD_REGEXP = `${MEDIUM_1}|${MEDIUM_2}|${MEDIUM_3}`;

// Весь пароль состоит из одного символа (111111111111111, aaaaaaaaaaaaa и т.д.)
const ALL_THE_SAME_REGEXP = /^(.)\1*$/;
/* eslint-enable */

export default {
  components: {
    RatingDescription,
  },

  props: {
    password: String,
    isDescriptionHintsOpen: Boolean,
  },

  computed: {
    rating() {
      let rating = WEAK_PASSWORD;

      if (!this.password) {
        rating = '';
        return rating;
      }

      if (this.password.match(ALL_THE_SAME_REGEXP)) {
        return rating;
      }

      if (this.password.match(STRONG_PASSWORD_REGEXP)) {
        rating = STRONG_PASSWORD;
      } else if (this.password.match(MEDIUM_PASSWORD_REGEXP)) {
        rating = MEDIUM_PASSWORD;
      }

      this.$emit('changeRating', rating);
      return rating;
    },
  },

  data() {
    return {
      linesCount: LINES_COUNT,
    };
  },

  methods: {
    hideHints($event) {
      if ($event.target.className === 'input-wrapper__input') {
        return;
      }

      this.$emit('descriptionHintsClick', false);
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

.password-rating {
  &__lines {
    display: flex;
  }

  .lines {
    &__item {
      flex: 1 1 0;
      height: 6px;
      background: $light-gray;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  &--weak {
    .lines__item:first-child {
      background: #d02202;
    }
  }

  &--medium {
    .lines__item:nth-child(-n + 2) {
      background: #f5da23;
    }
  }

  &--strong {
    .lines__item {
      background: #0bab4f;
    }
  }

  &__info {
    font-family: RobotoLight, sans-serif;
    font-size: 12px;
    color: #32393e;
    margin-top: 9px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;

    div:first-child {
      margin-left: 8px;
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  .password-rating {
    margin: 0 6px;
  }
}
</style>
